<template>
  <p>
    Legal Stuff: All credit for Metroid and Metroid Dread goes to Nintendo and Mercury Steam
    respectively. All metroid related assets on this site are intended as fan art and are released
    under a Creative Commons license. Please attribute, but if you don't nbd.
  </p>
</template>

<script></script>
